import { useEffect, useState } from 'react'
import Modal from '../../../components/Modal'
import { compareLatestOpearationWithOrigin, checkWCC } from '../WorkCenter/logic'
import { CgCheckO, CgCloseO } from 'react-icons/cg'
import { VscWarning } from 'react-icons/vsc'
const OrderConfirm = ({
  id, show, onHide, operationNo, actualWorkId,
  latestOp, onSubmitConfirm, isLoading, errorApi,
  isPartial, checkedLogs, listsOpFromSAP
}) => {

  const [result, setResult] = useState(null)
  const [resultCheckWCC, setResultCheckWCC] = useState(null)

  useEffect(() => {
    if (show) {
      const result = compareLatestOpearationWithOrigin(operationNo, actualWorkId, latestOp)
      setResult(result)
      const resultCheckWCC = checkWCC({listsOpFromSAP, currentOperationNo: operationNo, currentWorkCenterId: actualWorkId})
      setResultCheckWCC(resultCheckWCC)
    }
  }, [show, latestOp, operationNo, actualWorkId, listsOpFromSAP])

  const renderIcon = () => {
    if (!result) return null
    if (result.allow) {
      if (result.message) {
        return <VscWarning color="#ffc107"/>
      } else {
        if (resultCheckWCC && !resultCheckWCC.statusWCC) return <CgCloseO color="red" />
        return <CgCheckO color="green"/>
      }
    } else {
      return <CgCloseO color="red" />
    }
  }

  const displayCheckWCC = () => {
    if(resultCheckWCC && !resultCheckWCC.statusWCC){
      if(resultCheckWCC.actualOpCosting && resultCheckWCC.actualOpCosting['WC_NO']){
        return <div className='text-center mt-3'>
          <h5 className={`text-red-500 whitespace-pre-line`}>{`WorkCenter-C ที่ใช้จริง = ${actualWorkId}-C \n WorkCenter-C บน SAP = ${resultCheckWCC.actualOpCosting['WC_NO']}`}</h5>
        </div>
      }else{
        return <div className='text-center mt-3'>
          <h5 className={`mb-3 text-red-500 whitespace-pre-line`}>{`หาข้อมูล WorkCenter-C \n บน SAP : ${latestOp['WC_NO']}-C ไม่พบ`}</h5>
        </div>
      }
    }
    return false
  }

  const renderText = () => {
    if (!result) return null
    if (result.allow) {
      if (result.message) {
        return <div className='text-center mt-3'>
          <h5 className={`mb-3 text-[#ffc107] whitespace-pre-line`}>{result.message}</h5>
          <h6>{`WorkCenter ที่ใช้จริง = ${actualWorkId}`}</h6>
          <h6 className={`mb-3`}>{`WorkCenter บน SAP = ${latestOp['WC_NO']}`}</h6>
        </div>
      } else {
        const messageDisplayCheckWCC = displayCheckWCC()
        return messageDisplayCheckWCC ? messageDisplayCheckWCC : <h5 className={`mb-3 text-green-600`}>ข้อมูลตรงกับ SAP</h5>
      }
    } else {
      return <div className='text-center mt-3'>
        <h5 className={`mb-3 text-red-500 whitespace-pre-line`}>{result.message}</h5>
      </div>
    }
  }

  const renderTextConfirm = () => {
    if (!result) return null
    if (result.allow) {
      if (result.message) {
        return <h6>คุณแน่ใจที่จะยืนยัน ?</h6>
      } else {
        return <h6>กดยืนยันเพื่อ Confirm{isPartial ? ` ${checkedLogs.length} บรรทัด` : ''}</h6>
      }
    } else {
      return null
    }
  }

  const splitInLogs = [...new Set(checkedLogs.map(log => log.split))]

  const okDisable = isPartial && (checkedLogs.length === 0 || splitInLogs.length > 1)

  return <Modal
    show={show}
    title={`Confirm Order${isPartial ? ' บางส่วน / แยก Split' : ''}`}
    onHide={onHide}
    cancelText='ยกเลิก'
    okText={result && result.allow ? (isLoading ? 'Submit...' : 'ยืนยัน') : null}
    okAction={!isLoading ? () => onSubmitConfirm(id) : null}
    okTheme='success'
    okMoreStyles='w-24 disabled:bg-opacity-75'
    loading={isLoading}
    okDisable={okDisable}
  >
    <div className='text-center'>
      <div className="flex flex-col items-center justify-center">
        <h6 className='pb-3'>ผลลัพธ์การเชื่อมต่อข้อมูล กับ SAP</h6>
        <h1>{renderIcon()}</h1>
        {renderText()}
        {renderTextConfirm()}
        {okDisable ? <small className='mt-5 italic text-red-500'>หมายเหตุ : ถ้ากดยืนยันไม่ได้ กรุณาตรวจสอบที่เลือกไม่ควรมีหลาย split</small> : null}
      </div>
      <label className={`${errorApi ? '':'hidden'} text-red-500`}>{errorApi}</label>
    </div>
  </Modal>
}

export default OrderConfirm